import React from 'react';
import { CapturePropertyRobotDTO } from 'business/models/Models';
import RobotSettingsInput from '../robotSettingsInput';
import {
  getBrightFieldFocusingFields,
  getFocusingOptionsField,
  getImagingOptionsFields,
} from '../../utils';
import { frapPrefix } from '../../constants';
import { FrapConfigType } from '../../types';

interface FRAPImagingProps {
  robotCaptureProperties: CapturePropertyRobotDTO;
  robotId: number;
  handleChange: (propertyName: string, value: any) => void;
  handleFieldToggle: (propertyName: string, value?: any) => void;
  enabledFields: string[];
  lightPath: string;
  frapConfig: FrapConfigType;
}

function FRAPImaging(props: FRAPImagingProps) {
  const {
    robotCaptureProperties,
    robotId,
    handleChange,
    handleFieldToggle,
    enabledFields,
    lightPath,
    frapConfig,
  } = props;
  const prefix = lightPath?.toUpperCase() === 'FRAP' ? frapPrefix : '';

  return (
    <>
      <div id={`frap-imaging-${robotId}-imagingoptions-wrapper`} className="border p-2">
        <legend id={`frap-imaging-${robotId}-imagingoptions-title`} className="text-lg">
          Imaging Options
        </legend>
        <div
          id={`frap-imaging-${robotId}-imagingoptions-robotsettingsinput`}
          className="flex flex-row flex-wrap gap-x-12 gap-y-2"
        >
          {getImagingOptionsFields(prefix).map((ff, _idx) => (
            <RobotSettingsInput
              key={_idx}
              field={ff}
              value={robotCaptureProperties.data[robotId]?.[ff.PropertyName]}
              onChange={handleChange}
              onToggle={handleFieldToggle}
              enabled={enabledFields.includes(ff.PropertyName)}
              formData={robotCaptureProperties.data[robotId]}
              placeholder={frapConfig?.[ff.PropertyName]}
              defaultValue={frapConfig?.[ff.PropertyName]}
            />
          ))}
        </div>
      </div>
      <br />
      <div id={`frap-imaging-${robotId}-focusingoptions-wrapper`} className="border p-2">
        <legend id={`frap-imaging-${robotId}-focusingoptions-title`} className="text-lg">
          Focusing Options
        </legend>
        <RobotSettingsInput
          key={1}
          field={getFocusingOptionsField(prefix)}
          value={
            robotCaptureProperties.data[robotId]?.[
              getFocusingOptionsField(prefix).PropertyName
            ]
          }
          onChange={handleChange}
          onToggle={handleFieldToggle}
          enabled={enabledFields.includes(getFocusingOptionsField(prefix).PropertyName)}
          formData={robotCaptureProperties.data[robotId]}
          placeholder={frapConfig?.[getFocusingOptionsField(prefix).PropertyName]}
          defaultValue={frapConfig?.[getFocusingOptionsField(prefix).PropertyName]}
          customClassName="!w-[65%]"
        />
        <br id={`frap-imaging-${robotId}-breakline`} />
        <span id={`frap-imaging-${robotId}-brightfieldfocusing-title`}>
          Bright Field Focusing:
        </span>
        <div
          id={`frap-imaging-${robotId}-brightfieldfocusing-robotsettingsinput`}
          className="flex flex-row flex-wrap gap-x-12 gap-y-2"
        >
          {getBrightFieldFocusingFields(prefix).map((ff, _idx) => (
            <RobotSettingsInput
              key={_idx}
              field={ff}
              value={robotCaptureProperties.data[robotId]?.[ff.PropertyName]}
              onChange={handleChange}
              onToggle={handleFieldToggle}
              enabled={enabledFields.includes(ff.PropertyName)}
              formData={robotCaptureProperties.data[robotId]}
              placeholder={frapConfig?.[ff.PropertyName]}
              defaultValue={frapConfig?.[ff.PropertyName]}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default FRAPImaging;
